import { mockCmsIcon } from '@domgen/dgx-fe-cms';
import { CmsProtectionBenefitIconListItem } from '../../models/cms/cms-protection-benefit-icon-list-item.interface';

export const mockCmsProtectionBenefitIconListItem: CmsProtectionBenefitIconListItem =
  {
    benefit: 'benefit',
    icon: mockCmsIcon,
  };
